/* eslint-disable react/display-name */
/* eslint-disable @typescript-eslint/no-unused-vars */
// TODO: Fix unused vars
// TODO: Fix missing display name

import { createColumnHelper } from '@tanstack/react-table';
import {
  AppTabularColumn,
  AppTabularColumnGroup,
} from '../../../../components/reports/dtos/app-tabular.dto';
import { ReportsComponentProps } from '../../../../components/reports/interfaces/reports-component-props';
import { formatNumber } from '../../../../utils/formatting/number-formatter.helper';
import { ScenarioPlannerNumberCellComponent } from './scenario-planner-number-cell.component';
const defaultHeaderFactory = (col: AppTabularColumn, index: number) => {
  return (props: any) => col.name;
};
const defaultFooterFactory = (col: AppTabularColumn, index: number) => {
  return (props: any) => 'Total';
};
const columnHelper = createColumnHelper<any>();
export const ScenarioPlannerTableHelper = {
  parseColumns: (
    columns: AppTabularColumn[],
    cellFactory: (col: AppTabularColumn, index: number) => (props: any) => any,
    getColSize: (col: AppTabularColumn, index: number) => number,
    headerFactory: (
      col: AppTabularColumn,
      index: number,
    ) => (props: any) => any = defaultHeaderFactory,
    footerFactory: (
      col: AppTabularColumn,
      index: number,
    ) => (props: any) => any = defaultFooterFactory,
  ) => {
    if (columns === undefined) return [];
    return columns.map((col: AppTabularColumn, index: number) => {
      return {
        header: headerFactory(col, index),
        cell: cellFactory(col, index),
        footer: footerFactory(col, index),
        id: col.id,
        accessorFn: (row: any) => row[col.id],
        size: getColSize(col, index),
        isSorted: index === 0,
        meta: {
          className: col.id,
        },
      };
    });
  },
  parseMeasuresColumns: (
    columns: AppTabularColumn[],
    cellFactory: (col: AppTabularColumn, index: number) => (props: any) => any,
    getColSize: (col: AppTabularColumn, index: number) => number,
    data: any,
    total?: any,
    footerFactory = (col: AppTabularColumn, index: number) => (props: any) => (
      <ScenarioPlannerNumberCellComponent data={total} col={col} />
    ),
    headerFactory: (
      col: AppTabularColumn,
      index: number,
    ) => (props: any) => any = defaultHeaderFactory,
  ) => {
    if (columns === undefined) return [];
    return columns.map((col: AppTabularColumn, index: number) => {
      return {
        header: headerFactory(col, index),
        footer: footerFactory(col, index),
        cell: cellFactory(col, index),
        id: col.id,
        accessorFn: (row: any) => formatNumber(row[col.id]),
        size: getColSize(col, index),
        isSorted: index === 0,
        meta: {
          align: 'right',
          className: col.id,
        },
      };
    });
  },

  parseGroupMeasuresColumns: (
    columns: AppTabularColumn[],
    cellFactory: (col: AppTabularColumn, index: number) => (props: any) => any,
    getColSize: (col: AppTabularColumn, index: number) => number,
    data: any,
    total?: any,
    footerFactory = (col: AppTabularColumn, index: number) => (props: any) => (
      <ScenarioPlannerNumberCellComponent data={total} col={col} />
    ),
    headerFactory: (
      col: AppTabularColumn,
      index: number,
    ) => (props: any) => any = defaultHeaderFactory,
    columnGroups?: AppTabularColumnGroup[],
  ) => {
    if (columns === undefined) return [];

    if (columnGroups) {
      const groupedMeasureColumns = columnGroups
        .filter((g) => columns.find((i) => i.groupId === g.id))
        .map((g, gIndex) => {
          // We need configuration of the column that where the user enters value.
          const inputCol = columns.find(
            (c) => c.groupId === g.id && `${g.id}_INPUT` === c.id,
          );
          return columnHelper.group({
            id: g.id,
            // Copies input column metadata to create grouped header accordingly.
            header: inputCol
              ? headerFactory({ ...inputCol, name: g.name }, gIndex)
              : g.name,
            meta: {
              className: g.id,
            },
            // Columns of the group
            columns: columns
              .filter((i) => i.groupId === g.id)
              .map((col: AppTabularColumn, index: number) => {
                return {
                  // Temporary Changes column name if it is an input column.
                  header: defaultHeaderFactory(col, index),
                  footer: footerFactory(col, index),
                  cell: cellFactory(col, index),
                  id: col.id,
                  accessorFn: (row: any) => formatNumber(row[col.id]),
                  size: getColSize(col, index),
                  isSorted: index === 0,
                  meta: {
                    align: 'right',
                    className: col.id,
                  },
                };
              }),
          });
        });
      return groupedMeasureColumns;
    } else {
      return ScenarioPlannerTableHelper.parseMeasuresColumns(
        columns,
        cellFactory,
        getColSize,
        footerFactory,
        headerFactory,
      );
    }
  },
};

export interface ScenarioPlannerTableComponentProps
  extends ReportsComponentProps {
  totalReportName: string;
  onRowSelectionChange?(row: any): void;
  idField?: string;
  setInvalidateQuery?: (value: { invalidateQuery: () => Promise<any> }) => void;
  height: number | string | undefined;
}
